import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ActiveCampaignDistributionSection } from "../components/ActiveCampaignDistributionSection";
import { ActiveCampaignsSection } from "../components/ActiveCampaignsSection";
import { IntegrationsSection } from "../components/IntegrationsSection";
import { KpiTiles } from "../components/KpiTiles";
import { QuickActionsSection } from "../components/QuickActionsSection";
import { SegmentCountChart } from "../components/SegmentCountChart";
import { useGreeting } from "../hooks/useGreeting";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import { SegmentTourHomeCard } from "@/features/segments/tour/SegmentTourHomeCard";
import { useAuth } from "@/lib/hooks/useAuth";

function HomePage() {
  const { t } = useTranslation();
  // Present when an admin/superadmin opens /clients/:clientId/home. Absent for
  // client-context users on /home, who rely on JWT-derived scope.
  const { clientId } = useParams();
  const { firstName } = useAuth();
  const greeting = useGreeting(firstName);

  return (
    <ModernPageLayout title={greeting} subtitle={t("home.subtitle")}>
      <div className="flex flex-col gap-8">
        <SegmentTourHomeCard />
        <KpiTiles clientId={clientId} />
        <SegmentCountChart clientId={clientId} />
        <ActiveCampaignsSection clientId={clientId} />
        <div className="flex flex-col md:flex-row gap-4">
          <QuickActionsSection clientId={clientId} />
          <ActiveCampaignDistributionSection clientId={clientId} />
        </div>
        <IntegrationsSection clientId={clientId} />
      </div>
    </ModernPageLayout>
  );
}

export default HomePage;
